PopOver = require 'views/lib/pop-over'
CardMemberSelectView = require 'views/card/card-member-select-view'
DatePickerView = require 'views/card/date-picker-view'
trackUe = require 'debug/trackUe'
l = require 'lib/localize'

UP_NEXT_TYPE = 'UP_NEXT'
HIGHLIGHT_TYPE = 'HIGHLIGHTS'

getTrackingMethod = (type, menuItemName) =>
  method =
    if type == 'UP_NEXT'
    then "by clicking #{menuItemName} menu item on up next card"
    else "by clicking #{menuItemName} menu item on highlights card"

onCardSubscriptionClick = (card, type, trackingPrepositionalObject) =>
  isSubscribed = card.isSubscribed()

  actionVerb = if isSubscribed then 'unsubscribes' else 'subscribes'
  menuItemName = if isSubscribed then 'unsubscribe' else 'subscribe'
  method = getTrackingMethod(type, menuItemName)
  trackUe('home', actionVerb, 'card', trackingPrepositionalObject, '', method, { cardId: card.id })

  card.subscribe(!isSubscribed)
  PopOver.hide()

onClickAddDueDate = (card, type, modelCache, trackingIndirectObject) =>
  actionVerb = if card.getDueDate()? then 'changes' else 'adds'
  method = getTrackingMethod(type, 'due date')
  trackUe('home', actionVerb, 'due date', '', trackingIndirectObject, method, { cardId: card.id })

  PopOver.pushView
    view: DatePickerView
    options: { model: card, modelCache }

onClickAddMembersToCard = (card, type, modelCache, trackingIndirectObject) =>
  method = getTrackingMethod(type, 'members')
  trackUe('home', 'changes', 'members', '', trackingIndirectObject, method, { cardId: card.id })

  PopOver.pushView
    view: CardMemberSelectView
    options: { model: card, modelCache }

getOverflowItems = (card, type, modelCache, trackingPrepositionalObject, trackingIndirectObject) =>
  overflowMenuItems = []

  trackingPrepositionalObject = if trackingPrepositionalObject then trackingPrepositionalObject else ''
  trackingIndirectObject = if trackingIndirectObject then trackingIndirectObject else ''

  cardSubscriptionText =
    if card.isSubscribed()
    then l('home card overflow menu title.stop watching')
    else l('home card overflow menu title.watch')

  overflowMenuItems.push({ name: cardSubscriptionText, onClick: onCardSubscriptionClick.bind(null, card, type, trackingPrepositionalObject) })

  if type == UP_NEXT_TYPE && card.editable()
    overflowMenuItems.push({
      name: if card.getDueDate()? then l('home card overflow menu title.change due date') else l('home card overflow menu title.add due date')
      onClick: onClickAddDueDate.bind(null, card, type, modelCache, trackingIndirectObject)
    }, {
      name: l('home card overflow menu title.add members to card')
      onClick: onClickAddMembersToCard.bind(null, card, type, modelCache, trackingIndirectObject)
    })

  return overflowMenuItems

module.exports = {
  getOverflowItems
  UP_NEXT_TYPE
  HIGHLIGHT_TYPE
}



// WEBPACK FOOTER //
// ./app/scripts/views/home/overflow-menu.coffee